export const watchScrollDirection = function (scrollElement, callback) {
  const scrollPos = { x: 0, y: 0 };
  const scrollDirection = {
    directionX: 1,
    directionY: 1
  };
  let previousTimer;
  function onScroll(e) {
    const scrollTop = scrollElement.scrollTop || scrollElement.pageYOffset;
    const scrollLeft = scrollElement.scrollLeft || scrollElement.pageXOffset;

    if (scrollPos.y > scrollTop) {
      scrollDirection.directionY = -1;
    } else {
      scrollDirection.directionY = 1;
    }
    if (scrollPos.x > scrollLeft) {
      scrollDirection.directionX = -1;
    } else {
      scrollDirection.directionX = 1;
    }

    callback.call(scrollElement, scrollDirection, scrollPos);

    scrollPos.x = scrollLeft;
    scrollPos.y = scrollTop;
  }
  function throttle() {
    let now = Date.now();
    if (!previousTimer) previousTimer = now;
    if (now - previousTimer > 30) {
      onScroll();
      previousTimer = now;
    }
  }
  scrollElement.addEventListener("scroll", throttle);
  return function () {
    scrollElement.removeEventListener("scroll", throttle);
  };
};

export function formatDate(date, format = true) {
  date = new Date(date);
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  const Y = date.getFullYear();
  const M = (parseInt(date.getMonth()) + 1).toString().padStart(2, 0);
  const d = date
    .getDate()
    .toString()
    .padStart(2, 0);
  const h = date
    .getHours()
    .toString()
    .padStart(2, 0);
  const m = date
    .getMinutes()
    .toString()
    .padStart(2, 0);
  const s = date
    .getSeconds()
    .toString()
    .padStart(2, 0);

  return format ? `${Y}-${M}-${d} ${h}:${m}:${s}` : `${Y}-${M}-${d}`;
}

export function getOffsetTop(relativeNode, node, topSum = 0) {
  topSum += node.offsetTop;

  if (node.offsetParent !== relativeNode) {
    return getOffsetTop(relativeNode, node.offsetParent, topSum);
  }
  return topSum;
}

export function pick(obj = {}, keys = []) {
  const result = {};
  keys.forEach(key => {
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children"
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}


export function getTagColor(tagText) {
  let keywordColorMap = [
    { keyword: "视力残疾", color: "#ebf6f1" },    
    { keyword: "听力残疾", color: "#fff7ec" },    
    { keyword: "言语残疾", color: "#fcedef" },    
    { keyword: "精神残疾", color: "#fff7ec" }, 
    { keyword: "智力残疾", color: "#ebf6f1" },   
    { keyword: "肢体残疾", color: "#ecf5fa" },  
    { keyword: "多重残疾", color: "#f1f2f1" },   
  ]

  // 遍历关键词映射表，优先匹配靠前的关键词
  for (const item of keywordColorMap) {
    // 模糊匹配：标签文本包含关键词即应用颜色（忽略大小写）
    if (tagText.toLowerCase().includes(item.keyword.toLowerCase())) {
      return item.color;
    }
  }
  // 未匹配到任何关键词，返回默认颜色
  return this.defaultColor;
}

/**
 * 防抖函数 在规定的时间内请求函数的次数
 * @param fn  需要执行的方法
 * @param t 执行的间隔时间
 */
export const Debounce = (fn, t) => {
  let delay = t || 500;
  let timer;
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }

    let callNow = !timer;

    timer = setTimeout(() => {
      timer = null;
    }, delay);

    if (callNow) fn.apply(this, args);
  };
};

/**
 * 节流函数 在规定的时间内请求函数的次数
 * @param fn  需要执行的方法
 * @param interval 执行的间隔时间
 */
export function _throttle(fn, interval) {
  let last = 0;
  let timer;
  const interVal = interval || 200;
  return function () {
    const th = this;
    const args = arguments;
    const now = new Date().getTime();
    if (last && now - last < interVal) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = new Date().getTime();
        // fn.apply(th, args)
      }, interVal);
    } else {
      last = new Date().getTime();
      fn.apply(th, args);
    }
  };
}

//残疾标签数据转换
export function formatDisabilityData(data) {
  const result = {};
  // Process each jobId group
  for (const jobId in data) {
    if (data.hasOwnProperty(jobId)) {
      result[jobId] = data[jobId].map((item) => {
        // Convert Chinese numbers to digits and remove "级"
        const levels = item.disabledLevel
          .map((level) => {
            const chineseNum = level.replace("级", "");
            const numMap = { 一: "1", 二: "2", 三: "3", 四: "4" };
            return numMap[chineseNum] || chineseNum;
          })
          .sort((a, b) => a - b); // Sort numerically

        // Determine the format based on level sequence
        let levelStr;
        if (
          levels.length > 1 &&
          levels[levels.length - 1] - levels[0] === levels.length - 1
        ) {
          // Continuous range (e.g. 1,2,3,4 → 1-4)
          levelStr = `${levels[0]}-${levels[levels.length - 1]}`;
        } else {
          // Non-continuous (e.g. 2,3,4 → 2-4)
          levelStr = levels.join(",");
        }

        // Add "级" suffix if the original had it
        const hasSuffix = item.disabledLevel.some((l) => l.includes("级"));
        const suffix = hasSuffix ? "级" : "";

        return `${item.disabledType}${levelStr}${suffix}`;
      });
    }
  }

  return result;
}

export function getColorById(id) {
  // // 简单哈希算法，将字符串 ID 转换为 HEX 颜色
  // let hash = 0;
  // for (let i = 0; i < id.length; i++) {
  //   hash = id.charCodeAt(i) + ((hash << 5) - hash);
  // }
  // let color = '#';
  // for (let i = 0; i < 3; i++) {
  //   const value = (hash >> (i * 8)) & 0xFF; // 取 R, G, B 分量
  //   color += ('00' + value.toString(16)).slice(-2); // 转 16 进制
  // }
  // return color;

  // 简单的哈希函数，将ID转换为颜色
  const colors = [
    '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
    '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
    '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A'
  ];
  return colors[id % colors.length];
}
